<template>
  <div class="hotwordConfig">
    <el-card
      v-for="(item, index) of hotwordList"
      :key="index"
      style="margin-bottom: 2%; position: relative"
    >
      <el-row :gutter="20" type="flex" align="middle">
        <el-col :span="2">{{ index + 1 }}</el-col>
        <el-col :span="17">
          <el-input v-model="item.name" size="small"></el-input>
        </el-col>
        <el-col :span="2" class="sortContainer">
          <i class="el-icon-sort-down" @click="down(index)"></i>
          <i class="el-icon-sort-up" @click="up(index)"></i>
        </el-col>
        <el-col :span="1"
          ><i class="el-icon-delete remove" @click="remove(index)"></i
        ></el-col>
      </el-row>
    </el-card>
    <el-card style="text-align: center">
      <el-link type="primary" @click="create">
        <i
          class="el-icon-circle-plus-outline"
          style="font-weight: bold; text-decoration: none"
        ></i>
        新增热搜词</el-link
      >
    </el-card>

    <el-divider></el-divider>
    <el-row
      class="buttonContainer"
      style="display: flex; justify-content: flex-end"
    >
      <el-button @click="initData">重置</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "HotwordConfig",
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeTab: "quotation",
      hotwordList: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    create() {
      this.hotwordList.push({
        name: "",
      });
    },
    remove(index) {
      this.hotwordList.splice(index, 1);
    },
    up(index) {
      let item = this.hotwordList.splice(index, 1);
      if (index > 0) {
        this.hotwordList.splice(index - 1, 0, ...item);
      } else {
        this.hotwordList.push(...item);
      }
    },
    down(index) {
      let item = this.hotwordList.splice(index, 1);
      if (this.hotwordList[index]) {
        this.hotwordList.splice(index + 1, 0, ...item);
      } else {
        this.hotwordList.unshift(...item);
      }
    },
    initData() {
      this.axios.get(`/api/admin_website_config/${this.name}/`).then((data) => {
        this.hotwordList = JSON.parse(data.value);
      });
    },
    submit() {
      this.axios
        .put(`/api/admin_website_config/${this.name}/`, {
          name: this.name,
          group: "hotword",
          value: JSON.stringify(this.hotwordList),
        })
        .then(() => {
          this.initData();
        });
    },
  },
};
</script>

<style scoped lang="scss">

</style>

